<ng-container *ngFor="let item of categories">
  <div class=" filter-chip-selected">
    <div class="filter-chip" *ngIf="item.filters && item.filters.length > 0 && item.selected && item.name !== '7 Days' && item.name !== 'All'"
      [style.backgroundColor]="item.color ? item.color : ''" (click)="selectFilters(item, false)">
      <img (click)="openDialog($event, item.description, item.name)" class="img-style" src="./assets/icons/info.svg" alt=""
        *ngIf="item.description && item.description !== 'delete'">
      <!-- <img (click)="delete(item.name)" class="img-style" src="./assets/icons/delete.svg" alt=""
        *ngIf="item.description && item.description === 'delete'"> -->
      <img class="filter-image img-style" *ngIf="item.iconUrl" src="{{ item.iconUrl }}" alt="" />
      <img class="img-style" src="./assets/icons/layer_data.svg" alt="" *ngIf="item.name == 'Data layer'">
      <img class="img-style" src="./assets/icons/virtual_access.svg" alt="" *ngIf="item.name == 'Polarin metadata catalogue - virtual access'">
      <img class="img-style" src="./assets/icons/polarin_metadata_catalog.svg" alt="" *ngIf="item.name == 'Polarin metadata catalogue'">
      <span class="filter-text">{{item.name}}</span>
    </div>
  </div>
  <emodnet-menu-selected class="grid-auto-rows" [categories]="item.categories"
    (click)="selectFilters(item, false)"></emodnet-menu-selected>
</ng-container>
